
import React from 'react';
import './Infocard.css';

function InfoCard({handleNavigate}) {
  return (
    <div className="info-wrapper">
      <div className="info-container">
        <div className="info-text">
          <p>
            Voice-driven insights. Our AI detects emotion, flags risk, and computes real-time trust metrics all with privacy-first architecture.
          </p>
          <button className="info-btn" onClick={handleNavigate}>Explore the anaylzer</button>
        </div>
        <div className="info-image">
          <img src="/FutureAi_intro.png" alt="AI Trust Detection" />
        </div>
      </div>
    </div>
  );
}

export default InfoCard;


